import React from 'react';
import { Button, Result, message } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
    message.error('Something went wrong. Please try again or contact support.', 3);
  }

  handleRedirect = () => {
    if (this.props.navigate) {
      this.props.navigate('/rubus/DigitalTwinConfiguration');
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '90vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Result
            status="error"
            title="Something Went Wrong in 3D"
            subTitle="Please try to redirect to Twin Configuration, or contact support if the problem persists."
            extra={[
              <Button type="primary" onClick={this.handleRedirect} key="back">
                Redirect to DigitalTwinConfiguration
              </Button>
            ]}
          />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
